// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const topTenCoursesCompletedQuery = gql`
  query TopTenCoursesCompleted(
    $organizationId: String!
    $dateRange: String!
    $companySize: String!
    $industry: String!
  ) {
    topTenCoursesCompleted(
      organizationId: $organizationId
      dateRange: $dateRange
      companySize: $companySize
      industry: $industry
    ) {
      similarSizeCompletedCoursesFromMyOrg
      similarIndustryCompletedCoursesFromMyOrg
      similarSize
      similarIndustry
      similarSizeChartLabels
      similarIndustryChartLabels
    }
  }
`;
